import script from "./Spin.vue?vue&type=script&setup=true&lang=js"
export * from "./Spin.vue?vue&type=script&setup=true&lang=js"

import "./Spin.vue?vue&type=style&index=0&id=2a0e27ff&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0e27ff"]])

export default __exports__